import { IRPC } from '@prisma/studio-types'

/**
 * Interface to be implemented by a valid Studio transport on the browser side
 */
export interface ITransportBrowser {
  /**
   * An optional method that allows (async) initialization (if needed)
   */
  init?(): Promise<void>

  /**
   * Receives a semi-valid RPC request and is expected to deliver this message to a backend, retreiving a response
   *
   * The implementor is expected to supply a `requestId` to this request before sending it out to a backend.
   */
  request<T extends IRPC>(
    request: Omit<T['request'], 'requestId'>
  ): Promise<T['response']['payload']>
}

export { default as HTTPBrowserTransport } from './http'
export { default as ElectronBrowserTransport } from './electron'
